/** Rubrique Formats de bouteille : liste (nom, contenance, verres/btl, casier par défaut). */
import { useQuery } from '@tanstack/react-query';
import { parametresApi } from '../../../services/api';
import { Spinner, Card } from '../../../components/ui/kit';

export default function Formats() {
  const { data, isLoading } = useQuery({ queryKey: ['params-meta'], queryFn: parametresApi.meta });
  if (isLoading) return <Spinner />;
  const formats = data.bottle_formats || {};
  return (
    <div className="max-w-[640px]">
      <h2 className="font-title text-3xl mb-5">Formats de bouteille</h2>
      <Card className="overflow-hidden">
        <table className="w-full text-[13.5px]" data-testid="formats-table">
          <thead><tr className="text-left kicker"><th className="py-2.5 px-3">Format</th><th className="py-2.5 px-3 text-right">Contenance</th><th className="py-2.5 px-3 text-right">Verres / btl</th></tr></thead>
          <tbody>
            {Object.entries(formats).map(([key, f]) => (
              <tr key={key} className="hair-t" data-testid={`format-${key}`}>
                <td className="py-2.5 px-3">{f.label || key}</td>
                <td className="py-2.5 px-3 text-right nums">{f.cl ? `${f.cl} cl` : (f.ml ? `${f.ml} ml` : '—')}</td>
                <td className="py-2.5 px-3 text-right nums">{f.glasses || (f.cl ? Math.round(f.cl / 12) : '—')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
